import { stepUpStore } from "@/auth/step-up-store"

/**
 * `X-Step-Up` for an `x-step-up: true` operation (LLD §5.1, §6.7), as the
 * generated hook's `request.headers`. The generated mutation fixes its
 * request options when the hook is created, but the token arrives later (and
 * expires), so this is iterated when the mutation RUNS, not when the hook is
 * made. Two paths do it, both at call time: an operation with a body spreads
 * it through the generated `getHeaders()` (`Array.from` over the iterable),
 * and a body-less one hands it to the mutator, whose `new Headers(init)`
 * iterates it. Each finds the token the store holds at that moment, or none
 * (the server then answers 403 `step_up_required`). Both paths are pinned by
 * `src/auth/step-up-store.test.ts`.
 */
export const STEP_UP_HEADERS = {
  *[Symbol.iterator](): Generator<[string, string]> {
    const token = stepUpStore.get()
    if (token) yield ["X-Step-Up", token]
  },
} as unknown as HeadersInit
